<template>
	<a-modal
		title="新增项目"
		:visible="disabled"
		:confirm-loading="confirmLoading"
		:maskClosable="false"
		okText="提交"
		cancelText="取消"
		@ok="handleOk"
		@cancel="handleCancel"
	>
		<div class="oneDiv">
			<p>项目名称：</p>
			<a-input
				class="input"
				placeholder="请输入项目名称"
				v-model="formData.projectName"
			/>
		</div>
		<div class="oneDiv">
			<p>项目工作组：</p>
			<a-select
				mode="multiple"
				:default-value="chooseList"
				placeholder="请选择工作组"
				class="input"
				@change="handleChange"
			>
				<a-select-option
					:value="worker.groupId"
					v-for="(worker, index) in workerList"
					:key="index"
				>
					{{ worker.groupName }}
				</a-select-option>
			</a-select>
		</div>
		<!-- <div class="oneDiv">
			<p>地区：</p>
			<a-cascader
				class="input"
				:options="options"
				change-on-select
				@change="onChange"
				placeholder="请选择地区"
				style="width: 300px"
			/>
		</div> -->
		<div class="oneDiv">
			<p>项目描述：</p>
			<a-textarea
				class="input"
				v-model="formData.projectIntroduction"
				placeholder="请输入项目描述"
				:auto-size="{ minRows: 3, maxRows: 5 }"
			/>
		</div>
	</a-modal>
</template>

<script>
export default {
	inject: ['reload'],
	name: 'projectModal',
	data() {
		return {
			confirmLoading: false,
			formData: {},
			options: [],
			workerList: [],
			chooseList: [],
			groupIdList: sessionStorage.getItem('groupId'),
		}
	},
	props: ['disabled'],
	mounted() {
		this.getArea()
		this.getWorker()
	},
	methods: {
		// 新增项目
		handleOk() {
			if (
				!this.formData.projectName ||
				!this.formData.groupIdList ||
				!this.formData.orgId ||
				!this.formData.projectIntroduction
			) {
				return this.$message.warning('请填写完整')
			}
			this.$axios
				.post(this.api + '/project/add', this.formData)
				.then((res) => {
					if (res.code === 200) {
						this.$emit('showModal', false)
						this.$message.success('添加成功')
						this.formData = {}
						this.reload()
					}
				})
		},
		handleCancel(e) {
			this.$emit('showModal', false)
			this.formData = {}
		},
		onChange(label) {
			this.formData.orgId = label.slice(-1)[0]
		},
		// 获取地区
		getArea() {
			this.$axios.get(this.api + '/project/search').then((res) => {
				if (res.code === 200) {
					this.options = this.listToTree(res.data)
				}
			})
		},
		listToTree(list, parentId = '') {
			return list
				.filter((item) => item.parentId === parentId)
				.map((item) => ({
					...item,
					label: item.orgName,
					value: item.id,
					children: this.listToTree(list, item.id),
				}))
		},
		//查询工作组
		getWorker() {
			this.$axios
				.get(this.api + `/group/list?groupIdList=${this.groupIdList}`)
				.then((res) => {
					if (res.code === 200) {
						this.workerList = res.data.list
					}
				})
		},
		handleChange(value) {
			// console.log(value);
			this.chooseList = value
			this.formData.groupIdList = value
		},
	},
}
</script>

<style scoped>
.input {
	width: 70% !important;
}
.oneDiv {
	display: flex;
	font-size: 14px;
	margin: 15px;
}
.oneDiv > p {
	width: 100px;
}
</style>
